export default "__VITE_ASSET__CoZn3EHP__"